export interface ChannelSettingsDto {
  faqBannerImage: string | null;
  faqPageTitle: string | null;
  faqPageDescription: string | null;
}

export const DEFAULT_FAQ_PAGE_TITLE = 'Frequently Asked Questions';
export const DEFAULT_FAQ_BANNER_IMAGE = 'assets/images/shop-hero.png';
export const DEFAULT_FAQ_PAGE_DESCRIPTION =
  "From day one, we've been committed to growing our crops responsibly, sustainably and deliciously. And we've learned a thing or two along the way. So if you've got questions about organic farming, water conservation, soil preservation or anything else rice-related, we've got answers.";
